<template>
    <div class="synthese-preconisation">
        <div class="tle-row">
        <div class="tle-col auto">
            <p class="label-small">Avis sur le potentiel de la résidence</p>
        </div>
        <div class="tle-col half self-end">
            <el-progress-slider
            :parent_data="
                active_study.etudeData.gie.sectionSynthesePreconisations
            "
            property="avis_potentiel_residence"
            :max="10"
            :editable="true"
            />
        </div>
        </div>

        <div class="tle-row">
        <div class="tle-col three-quarter">
            <el-table
            :table="synthese_preconisations_table"
            :lines-obj="active_study.etudeData.gie.sectionSynthesePreconisations"
            lines-field="synthese_preconisations_table_lines"
            lines-box-class="left lefter"
            variant="highlight-results"
            >
			<template v-slot:edition>
				<button @click="copyTableSurfaceLoyer()" v-show="editor.mode =='editing'" >Copier le tableau "caractéristiques et standing de la résidence"</button>
			</template>
			</el-table>
        </div>
        <div class="tle-col one-quarter self-end">
            <el-square
            :parent_data="
                active_study.etudeData.gie.sectionSynthesePreconisations
            "
            property="prix_stationnement"
            label="Prix stationnement"
            format="string"
            suffix="€"
            :editable="true"
            />
            <el-square
            :parent_data="
                active_study.etudeData.gie.sectionSynthesePreconisations
            "
            property="prix_vente_detail"
            label="Prix de vente au détail"
            format="string"
            suffix="€"
            class="q-mt-sm"
            :editable="true"
            />
            <el-square
            :parent_data="
                active_study.etudeData.gie.sectionSynthesePreconisations
            "
            property="prix_vente_bloc"
            label="Prix de vente en bloc"
            format="string"
            suffix="€"
            class="q-mt-sm"
            :editable="true"
            />
        </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import _ from "lodash";
import number from "@/libs/number";
import PageMixin from "@/components/study/editor/pages/page.mixin.js";
export default {
	mixins: [PageMixin],
	methods: {
		copyTableSurfaceLoyer (){
			this.$store.commit("EDIT_OBJECT", {
				obj: this.active_study.etudeData.gie.sectionSynthesePreconisations,
				field: "synthese_preconisations_table_lines",
				value: this.active_study.etudeData.gie.sectionCaracteristiquesResidence.surface_loyer_table_lines
			});
			this.$store.commit("EDIT_OBJECT", {
				obj: this.active_study.etudeData.gie.sectionSynthesePreconisations,
				field: "synthese_preconisations_table",
				value: _.cloneDeep(this.active_study.etudeData.gie.sectionCaracteristiquesResidence.surface_loyer_table),
			});
		}
	},
	computed: {
		...mapGetters([
			"active_study",
			"editor"
		]),
		synthese_preconisations_table_lines () {
			return parseInt(
				this.active_study.etudeData.gie.sectionSynthesePreconisations
					.synthese_preconisations_table_lines
			);
		},
		synthese_preconisations_table () {
			const table = {
				head: [],
				body: [],
				config: {
					cols_width: [10, 20, 20, 25, 25],
				},
			};

			table.head.push([
				"Type",
				"Nombre",
				"Surf. hab.",
				"Prix unitaire",
				"Prix/m²",
			]);

			const total = {
				nb: 0,
				surf_hab: 0,
				prix_unit: 0,
				prix_m2: 0,
			};
			let prix_m2;
			for (let i = 0; i < this.synthese_preconisations_table_lines; i++) {
				const loc =
			this.active_study.etudeData.gie.sectionSynthesePreconisations
				.synthese_preconisations_table[i];
				prix_m2 =loc.surf_hab=="0"|| typeof loc.prix_unit === "undefined" ? 0: Math.round((parseInt(loc.prix_unit)/parseInt(loc.surf_hab))/10)*10;
				total.nb += number.clean(loc.nb);
				total.surf_hab += number.clean(loc.surf_hab) * number.clean(loc.nb);
				total.prix_unit += typeof loc.prix_unit === "undefined"?0:number.clean(loc.prix_unit) * number.clean(loc.nb);
				total.prix_m2 += prix_m2 * number.clean(loc.nb);

				const rows = [
					{ parent_data: loc, property: "type", editable: true },
					{
						parent_data: loc,
						property: "nb",
						editable: true,
					},
					{
						parent_data: loc,
						property: "surf_hab",
						editable: true,
						suffix: " m²",
					},
					{
						value: number.format(loc.prix_unit, 1),
						parent_data: loc,
						property: "prix_unit",
						editable: true,
						suffix: typeof loc.prix_unit !== "undefined" ? " €" : "-",
					},
					{
						value: prix_m2,
						editable: false,
						suffix: prix_m2 == "-" ? "" : " €",
					},
				];

				table.body.push(rows);
			}

			table.body.push([
				"Total/Moy.",
				number.format(total.nb, 0),
				{
					value: number.format(total.surf_hab / total.nb, 1),
					suffix: " m²",
				},
				{
					value: Math.round((total.prix_unit / total.nb)/100)*100,
					suffix: " €",
				},
				{
					value: Math.round((total.prix_m2 / total.nb)/10)*10,
					suffix: " €",
				},
			]);

			return table;
		},
	}
};
</script>
<style lang="stylus" scoped>
@import '../../../../../assets/css/app'
@import '../../../../../assets/css/page'
</style>
